type FieldWithPolicyScope = Pick<Diagonal.Data.Data.FieldData, 'policy_scope'>;
type ResourceWithPolicyScope = Pick<Diagonal.Data.Data.ResourceData, 'policy_scope'>;

/**
 * Returns true when the identity has access to the given field under the target scope.
 * A null or absent `policy_scope` means unrestricted — the field is accessible.
 */
export function hasFieldAccess(
  field: FieldWithPolicyScope | null | undefined,
  targetScope: number
): boolean {
  if (!field || field.policy_scope == null) {
    return true;
  }
  return (field.policy_scope & targetScope) !== 0;
}

/**
 * Returns true when the identity has resource-level access for the target scope.
 * A null or absent `policy_scope` means unrestricted.
 */
export function hasResourceAccess(
  resource: ResourceWithPolicyScope | null | undefined,
  targetScope: number
): boolean {
  if (!resource || resource.policy_scope == null) {
    return true;
  }
  return (resource.policy_scope & targetScope) !== 0;
}
